import { Badge } from "components/Atoms/Badge"
import { PhosphorCheckCircle, PhosphorHourglass } from "components/Atoms/PhosphorIcon"
import moment from "moment"
import React from "react"
import { formatWrittenDayMonthYear, formatWrittenDayMonthYearShort } from "utilities"

interface Props {
  progress: server.dto.ESignParticipantProgress
  signedUtc: Date | null
}

const ESignParticipantProgressBadge = (props: Props) => {
  switch (props.progress.value) {
    case "waitingForSigner":
      return <Badge
        iconComp={PhosphorHourglass}
        label={RESX.ESign.WaitingForSigner}
        variant="yellow"
      />
    case "senderAutoSignActive":
      return <Badge
        iconComp={PhosphorHourglass}
        label={RESX.ESign.AutosignActive}
        variant="yellow"
      />
    case "manuallyCompleted":
      return <Badge
        iconComp={PhosphorCheckCircle}
        label={RESX.ESign.ManuallyCompleted}
        variant="primary"
      />
    case "automaticallyCompleted":
      return <Badge
        iconComp={PhosphorCheckCircle}
        label={RESX.ESign.AutomaticallySigned}
        sublabel={formatWrittenDayMonthYearShort(moment.utc(props.signedUtc))}
        variant="green"
      />
    case "readyForSigning":
      return <Badge
        iconComp={PhosphorHourglass}
        label={RESX.ESign.PendingSignature}
        variant="yellow"
      />
    case "signedByPerson":
      return <Badge
        iconComp={PhosphorCheckCircle}
        label={RESX.ESign.Signed}
        sublabel={formatWrittenDayMonthYear(moment.utc(props.signedUtc))}
        variant="green"
      />
    default:
      return null;
  }
}

export default ESignParticipantProgressBadge;